import { WatchQueryFetchPolicy } from '@apollo/client'

import { ContractorHistoryTranslator } from 'src/translators'
import { useGetContractorHistoriesQuery } from 'src/types/generated'

type Input = {
  roomId: string
  fetchPolicy?: WatchQueryFetchPolicy
}

export const useGetRoomContractorHistories = ({ roomId, fetchPolicy }: Input) => {
  const { data, loading, refetch } = useGetContractorHistoriesQuery({
    variables: { roomId: Number(roomId) },
    fetchPolicy,
  })

  return {
    roomContractorHistories: data
      ? ContractorHistoryTranslator.toEntities({ response: data.selectContractorHistories })
      : [],
    loading,
    refetch,
  }
}
